import { get } from 'lodash';

import { ensureArray } from 'utils/arrays';

export const getPaginatedApiDataForDataTable = ({
  pages,
  dataPath = 'data',
  dataResultsPath = 'results',
}) => {
  const count = get(pages, `0.${dataPath}.count`) ?? 0;
  const allItems = {
    ...pages.reduce(
      (obj, { data }) => ({
        count,
        results: [...obj.results, ...ensureArray(data[dataResultsPath])],
      }),
      { count, results: [] },
    ),
  };

  return allItems;
};

export const formatOrder = ({ order, orderBy }) => {
  if (!orderBy || !order) {
    return '';
  }
  const prefix = order === 'asc' ? '' : '-';
  return `${prefix}${orderBy}`;
};
